import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import LangSelectModal from '@components/_commons/header/langSelect/LangSelectModal';

function LangButtons() {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false); // 추가: 모달 열기 상태

    const lang = useSelector(state => state.ui.lang);

    const toggleModal = () => {
        setIsOpen(!isOpen); // 모달 열기/닫기 토글
    };
    return (
        <>
            <div style={{ padding: '30px 10px', borderBottom: '1px solid #ddd' }}>
                <div style={{ marginBottom: 15 }}>{t('settings.general.language')}</div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, flexDirection: 'row', justifyContent: 'center' }}>
                    <button
                        className="language-button"
                        onClick={toggleModal}
                    >
                        {lang?.endonym}
                    </button>
                </div>
            </div>
            <LangSelectModal isOpen={isOpen} toggleModal={toggleModal} />
        </>
    );
}

export default LangButtons;